const SvgOrangeCardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#F69133"
      stroke="#F79133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.513 4.09h12.962c4.153 0 5.191 1.026 5.191 5.12v9.58c0 4.094-1.038 5.12-5.18 5.12H7.513c-4.142.012-5.18-1.014-5.18-5.11V9.21c0-4.094 1.038-5.12 5.18-5.12"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M2.333 9.922h23.333M7 19.256h2.333M12.25 19.256h4.667"
    />
  </svg>
);
export default SvgOrangeCardIcon;
